import { render, staticRenderFns } from "./GiftCardsPage.vue?vue&type=template&id=3ee88ba7"
import script from "./GiftCardsPage.vue?vue&type=script&lang=js"
export * from "./GiftCardsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports